import { z } from 'zod';
import { onboardingApi } from '../onboarding.api';

const getPasscodeStatusResDTOSchema = z.strictObject({
  exists: z.boolean(),
});

export type TGetPasscodeStatusResDTO = z.infer<
  typeof getPasscodeStatusResDTOSchema
>;

interface TSetPasscodeQueryArg {
  passcode: string;
}

/**
 * The backend resolves the client from the WebID token, so no client
 * identifier is sent.
 */
export const passcodeApi = onboardingApi.injectEndpoints({
  endpoints: (build) => ({
    getPasscodeStatus: build.query<TGetPasscodeStatusResDTO, void>({
      query: () => ({ url: '/passcode' }),
      // Parse at the network boundary so a contract change fails here, not in the UI.
      transformResponse: (response: unknown) =>
        getPasscodeStatusResDTOSchema.parse(response),
    }),
    setPasscode: build.mutation<void, TSetPasscodeQueryArg>({
      query: ({ passcode }) => ({
        url: '/passcode',
        method: 'PUT',
        body: { passcode },
      }),
    }),
  }),
});

export const {
  useGetPasscodeStatusQuery,
  useSetPasscodeMutation,
} = passcodeApi;
